// import React from 'react'
// import { Link } from 'react-router-dom'
// import logoProductionCapabilities from "../../imagens/logos/logoProductionCapabilities.png"
// import imgWireCapabilities from "../../imagens/wires/wireCapabilities.png"
// import imgTestCapabilities from "../../imagens/testCapabilities.png"
// import imgMachineCapabilities from "../../imagens/machineCapabilities.png"
// import imgPlasticParts from "../../imagens/pecasplasticas/plasticCapabilities.png"
// import imgWeldCapabilities from "../../imagens/welds/imgWeldCapabilties.png"
// import imgWireProduction from "../../imagens/imgWireProduction.png"
// import imgMetrology from "../../imagens/metrology/imgMetrology.png"
// import imgStamping from "../../imagens/stamping/imgStampingCapabilities.png"

// import "./cardsProductionCapabilites.css"

// function CardsProductionCapabilities() {
//   return (
//     <div>
//       <div className="text-start ms-2">
//         <img className="img-fluid img-custom-size" src={logoProductionCapabilities} alt="Capabilities Logo" />
//       </div>
//       <div className="container-fluid pt-5">
//         <div className="row justify-content-around">
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/WireProduction">
//               <img src={imgWireProduction} className="img-fluid" alt="Test Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Wires Production</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Wires">
//               <img src={imgWireCapabilities} className="img-fluid" alt="Wire Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 s-md-5">Wire Harnesses and assemblies</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Plastics">
//               <img src={imgPlasticParts} className="img-fluid" alt="Plastic Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Plastic parts injection, overmoldings and assemblies</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Stamping">
//               <img src={imgStamping} className="img-fluid" alt="Stamping Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Stamping</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Weldings">
//               <img src={imgWeldCapabilities} className="img-fluid" alt="Welding Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Weldings and solderings</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/Equipments">
//               <img src={imgMachineCapabilities} className="img-fluid" alt="Machine Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2  s-md-5">Equipments</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width mx-2">
//             <Link className="text-decoration-none" to="/Capabilities/Production/WireChecks">
//               <img src={imgTestCapabilities} className="img-fluid" alt="Test Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Quality controls and checks</h2>
//             </Link>
//           </div>
//           <div className="col-md-3 col-sm-3 mb-4 hover-custom custom-width">
//             <Link className="text-decoration-none" to="/Capabilities/Production/MetrologyCapabilities">
//               <img src={imgMetrology} className="img-fluid" alt="Metrology Capabilities" />
//               <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5">Lab & Metrology</h2>
//             </Link>
//           </div>

//         </div>
//       </div>
//       <div className="text-center my-4">
//         <Link to="/Capabilities">
//           <button className="buttonCapabilities">Back to Capabilities</button>
//         </Link>
//       </div>
//     </div>
//   );
// }
// export default CardsProductionCapabilities

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Logos
import logoProductionCapabilities from "../../imagens/logos/logoProductionCapabilities.png";
import logoCapabilitiesEn from "../../imagens/logos/logoCapabilitiesEn.png";

// Imagens dos cards
import imgWireCapabilities from "../../imagens/wires/wireCapabilities.png";
import imgTestCapabilities from "../../imagens/testCapabilities.png";
import imgInjetados from "../../imagens/logoInjetado.png";
import imgWeldCapabilities from "../../imagens/welds/imgWeldCapabilties.png";

import "./cardsProductionCapabilites.css";

function CardsProductionCapabilities() {
  const { t, i18n } = useTranslation();

  // Escolhe logo conforme idioma
  const logoImg = i18n.language === "en" ? logoCapabilitiesEn : logoProductionCapabilities;

  // Dados dos cards com textos traduzidos
  const cardsData = [
    {
      img: imgWireCapabilities,
      alt: "Wire Capabilities",
      title: t("capabilities.cards.wires"),
      link: "/Capabilities/Production/Wires"
    },
    {
      img: imgInjetados,
      alt: "Injetados",
      title: t("capabilities.cards.injection"),
      link: "/Capabilities/Production/InjecaoPlastico"
    },
    {
      img: imgWeldCapabilities,
      alt: "Welding Capabilities",
      title: t("capabilities.cards.weldings"),
      link: "/Capabilities/Production/Weldings"
    },
    {
      img: imgTestCapabilities,
      alt: "Test Capabilities",
      title: t("capabilities.cards.qualityChecks"),
      link: "/Capabilities/Production/WireChecks"
    },
  ];

  return (
    <div>
      <div className='w-100 col-lg-12'>
        <div className="text-start ms-2">
          <img className="img-fluid img-custom-size" src={logoImg} alt="Capabilities Logo" />
        </div>
        <div className="pt-3 w-100">
          <div className="customrow w-100 justify-content-around">
            {cardsData.map((card, index) => (
              <div key={index} className="mb-4 hover-custom">
                <Link className="text-decoration-none" to={card.link}>
                  <img src={card.img} className="img-fluid" alt={card.alt} />
                  <h2 className="textCapabilities text-wrap text-center mt-2 fs-md-5 fw-bold">{card.title}</h2>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardsProductionCapabilities;
